import { AuditTrailActions } from 'utils/auditTrailActions';
import IdListDTO from '../IdListDTO';

export enum WidgetTenantControlChangesPeriods {
  Last2Days = 0,
  LastWeek = 1,
  LastMonth = 2,
  LastQuarter = 3,
  LastYear = 4,
  Last3Years = 5,
}

export class Widget71DTO {
  tenants: IdListDTO;

  actions: AuditTrailActions[];

  results?: Widget71ResultDTO[];

  constructor() {
    this.tenants = new IdListDTO([]);
    this.actions = [];
  }
}

export class Widget71ResultDTO {
  tenantId: string;

  data: { [K in keyof WidgetTenantControlChangesPeriods]?: number[] };

  constructor() {
    this.tenantId = '';
    this.data = {};
  }
}
